import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import {
  NgbAlert,
  NgbCollapse,
  NgbDropdown,
  NgbDropdownConfig,
  NgbDropdownMenu,
  NgbDropdownToggle
} from '@ng-bootstrap/ng-bootstrap';
import { AmaRequestData, LoggedInUser } from '../../service/model';
import { NavigationService } from '../../service/core/navigation.service';
import { ResolutionNavHelper } from '../../service/core/resolution-nav-helper.service';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectNavigation, selectShowPartitionSwitchPopup } from '../../store/navigation/navigation-selector';
import { MetaGroupSwitchAlertDisplayed } from '../../store/navigation/navigation-actions';
import { NgClass } from '@angular/common';
import { DfInsertIconDirective } from '@design-factory/design-factory';
import { selectAmaRequestData } from '../../store/core/selector';
import { FeatureFlags } from '../util/resources';
import { ConfigurationService } from '../../service/configuration/configuration.service';
import { CopyToClipboardButtonComponent } from '../../components/copy-to-clipboard-button/copy-to-clipboard-button.component';

@Component({
  selector: 'ama-ng-upp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [NgbDropdownConfig],
  standalone: true,
  imports: [
    NgbCollapse,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgClass,
    NgbAlert,
    DfInsertIconDirective,
    CopyToClipboardButtonComponent
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() user?: LoggedInUser;
  @Input() applicationName?: string;

  @Output() signOffClicked = new EventEmitter<void>();

  menuTitle = '';
  displayAlertPartitionChange = false;
  lookup = false;
  amaRequestData?: AmaRequestData;
  troubleshootingPanelActivate = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly navigationService: NavigationService,
    private readonly config: NgbDropdownConfig,
    private readonly resolutionNavHelper: ResolutionNavHelper,
    private readonly store: Store,
    private readonly configurationService: ConfigurationService
  ) {
    config.autoClose = true;
  }

  ngOnInit() {
    this.updateMenuTitleVisibility();
    this.subscriptions.push(
      this.navigationService.selectedMenuTitle.subscribe((updatedTitle) => {
        this.menuTitle = updatedTitle;
      })
    );
    this.store.pipe(select(selectNavigation)).subscribe((lookupParam) => {
      this.lookup = lookupParam && lookupParam.lookup !== undefined ? lookupParam.lookup : false;
    });
    this.subscriptions.push(
      this.store.pipe(select(selectShowPartitionSwitchPopup)).subscribe((showPopup) => {
        if (showPopup) {
          this.displayAlertPartitionChange = true;
          this.store.dispatch(new MetaGroupSwitchAlertDisplayed());
        }
      })
    );
    this.subscriptions.push(
      this.store.pipe(select(selectAmaRequestData)).subscribe((data) => {
        this.amaRequestData = data;
      })
    );
    this.subscriptions.push(
      this.configurationService.getParameter$(FeatureFlags.troubleshootingPanel).subscribe((troubleshootingPanel) => {
        this.troubleshootingPanelActivate = troubleshootingPanel ?? false;
      })
    );
  }

  onSignOffClicked() {
    this.signOffClicked.emit();
  }

  updateMenuTitleVisibility() {
    this.resolutionNavHelper.updateTitleVisibility();
  }

  isTitleHidden() {
    return this.resolutionNavHelper.isTitleCollapsed;
  }

  toggleSideNav() {
    this.resolutionNavHelper.toggleSideNav();
  }

  onSelectPartition(partition: string) {
    this.navigationService.selectPartition(partition);
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.subscriptions = [];
  }
}
